import { combineReducers } from 'redux';
import { i18n } from './i18n.reducer';
import { user } from './user.reducer';
import { chat } from './chat.reducer';
import { consultation } from './consultation.reducer';


const rootReducer = combineReducers({
    i18n,
    user,
    chat,
    consultation
});

export default rootReducer;
